import { baseApi } from "../api/baseApi";
export const projectStatusesApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        refreshProjectStatuses: builder.mutation({
            query: (body) => ({
                url: "ProjectStatuses/refresh",
                method: "POST",
                body,
            }),
        }),
        refreshProjectStatusesHierarchy: builder.mutation({
            query: (body) => ({
                url: "ProjectStatuses/refresh-hierarchy",
                method: "POST",
                body,
            }),
        }),
        resetProjectStatuses: builder.mutation({
            query: ({ companyId, parentProjectNumber, configMonth }) => ({
                url: `ProjectStatuses/reset-for-project?companyId=${companyId}&parentProjectNumber=${encodeURIComponent(parentProjectNumber)}&configMonth=${encodeURIComponent(configMonth)}`,
                method: "POST",
            }),
        }),
    }),
});
export const { useRefreshProjectStatusesMutation, useRefreshProjectStatusesHierarchyMutation, useResetProjectStatusesMutation, } = projectStatusesApi;
